import axios from './api';

const API_URL = '/galeries/';

const createGalerie = async (userData) => {
  const response = await axios.post(API_URL,userData);
  return response.data;
};


const getAll = async() => {
  const response = await axios.get(API_URL);
  return response.data;
};

const DeleteGalerie = async (id) => {
  const response = await axios.delete(API_URL + id);
  return response.data;
};



const GalerieService = {
  DeleteGalerie,
  getAll,
  createGalerie
};

export default GalerieService;
